/**
 * Analytics sink for Metro-map errors. The reducer emits `ReportError`
 * effects; the effects runner routes them to whatever
 * [MetroAnalyticsReporter] is configured.
 *
 * Mirrors iOS `MetroAnalyticsReporter` + Android `MetroAnalyticsReporter`.
 */
export type MetroAnalyticsReporter = (event: string, metadata: Record<string, unknown>) => void

/**
 * No-op reporter. Kept as the leaf-component default and for tests /
 * harness pages that must not emit. The REAL host reporter that forwards
 * to GA4 + Amplitude is `realMetroAnalyticsReporter` in
 * `src/analytics/webAnalyticsReporter.ts`; the AppShell call sites inject
 * it so production events actually leave the page.
 */
export const noopMetroAnalyticsReporter: MetroAnalyticsReporter = () => {
  // no-op
}
